import { CustomerTypePolicy } from "constants/company/CustomerTypePolicy";

export const CustomerTypeDroOpts = () => {


    const getCustomerTypeModel = () => {
        let items = [CustomerTypePolicy.SL, CustomerTypePolicy.AGENT, CustomerTypePolicy.SHIPPER, CustomerTypePolicy.CONSIGNEE, CustomerTypePolicy.BOTH];

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }
    const getCustomerTypeModelForOutputVatReport = () => {
        let items = [CustomerTypePolicy.SL, CustomerTypePolicy.CC];

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }
    const getCCCustomerTypeModel = () => {
        let items = [CustomerTypePolicy.AGENT, CustomerTypePolicy.SHIPPER, CustomerTypePolicy.CONSIGNEE, CustomerTypePolicy.BOTH];

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
            })) ?? [])];
    }

    return {
        getCustomerTypeModel,
        getCCCustomerTypeModel,
        getCustomerTypeModelForOutputVatReport
    }
}